import axios from 'axios';
import {api} from '../utils/helper';

//****************** GET All Tables by Date for EWAR ******************//
export const exportEWAR = async (a) => {
    try{
     // const a = { orgID: sessionStorage.getItem('org'), projID: sessionStorage.getItem('project')}
    const resrep = await axios.post(
      `${api}/exportEWAR`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );
//          console.log(`exportEWAR controller res: `, resrep);
          return resrep;
    }catch (error) {
//        console.log(`exportEWAR controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}